/* eslint-disable no-return-assign */
/* eslint-disable import/no-cycle */
import { action, makeObservable, observable } from 'mobx';
import { AccountInfo, AccountPaymentType, PaymentMethod, Person } from '../../swagger/api';
import BaseStore from '../base-stores/BaseStore';
import { RootStore } from '../RootStore';
import { DailyContactInformation } from '../../features/administration-features/edit-daily-contact/EditDailyContactModal';
import { GnssNotificationsInformation } from '../../Types';
import { InvoiceRecipient } from '../../features/administration-features/modals/EditInvoiceRecipientModal';
import { AccountStatementRecipient } from '../../features/administration-features/modals/EditAccountStatementRecipientModal';

export default class AccountInformationStore extends BaseStore {
  accountInfo?: AccountInfo = undefined;

  contractManager?: Person = undefined;

  dailyContactPerson?: Person = undefined;

  dailyContactPersonName?: string = undefined;

  dailyContactPersonEmail?: string = undefined;

  dailyContactPersonPhone?: string = undefined;

  gnssNotificationEmail?: string = undefined;

  globalGnssNotificationBatteryDischargedStatus?: boolean = false;

  globalGnssNotificationNoPowerStatus?: boolean = false;

  globalGnssNotificationNotOkPositionStatus?: boolean = false;

  globalGnssNotificationPushToApiStatus?: boolean = false;

  dailyPersonGnssEmailStatus?: boolean = false;

  paymentMethod?: PaymentMethod = undefined;

  accountPaymentType?: AccountPaymentType = undefined;

  invoiceEmailRecipient?: string = undefined;

  getAccountInfo = () => {
    this.accountInfo = this.rootStore.userStore.currentAccount;
    this.contractManager = {
      firstName: this.rootStore.userStore.currentAccount?.contractManagerFirstName,
      lastName: this.rootStore.userStore.currentAccount?.contractManagerLastName,
      email: this.rootStore.userStore.currentAccount?.contractManagerEmail,
      phoneNumber: this.rootStore.userStore.currentAccount?.contractManagerPhone
    } as Person;
    this.dailyContactPerson = this.rootStore.userStore.currentAccount?.dailyContactPerson;
    this.dailyContactPersonName = this.rootStore.userStore.currentAccount?.dailyContactPersonName;
    this.dailyContactPersonEmail = this.rootStore.userStore.currentAccount?.dailyContactPersonEmail;
    this.dailyContactPersonPhone = this.rootStore.userStore.currentAccount?.dailyContactPersonPhone;
    this.gnssNotificationEmail = this.rootStore.userStore.currentAccount?.gnssNotificationEmail;
    this.globalGnssNotificationBatteryDischargedStatus =
      this.rootStore.userStore.currentAccount?.globalGnssNotificationBatteryDischargedStatus;
    this.globalGnssNotificationNoPowerStatus =
      this.rootStore.userStore.currentAccount?.globalGnssNotificationNoPowerStatus;
    this.globalGnssNotificationNotOkPositionStatus =
      this.rootStore.userStore.currentAccount?.globalGnssNotificationNotOkPositionStatus;
    this.globalGnssNotificationPushToApiStatus =
      this.rootStore.userStore.currentAccount?.globalGnssNotificationPushToApiStatus;
    this.dailyPersonGnssEmailStatus =
      this.rootStore.userStore.currentAccount?.dailyPersonGnssEmailStatus;
    this.paymentMethod = this.rootStore.userStore.currentAccount?.paymentMethod;
    this.invoiceEmailRecipient = this.rootStore.userStore.currentAccount?.invoiceRecipientEmail;
    this.accountPaymentType = this.rootStore.userStore.currentAccount?.accountPaymentType;
  };

  setAndUpdateInvoiceRecipient(invoiceRecipient: InvoiceRecipient) {
    return this.rootStore.accountStore.requestToUpdateInvoiceRecipient(invoiceRecipient);
  }

  setAndUpdateAccountStatementRecipient(accountStatementRecipient: AccountStatementRecipient) {
    return this.rootStore.accountStore.requestToUpdateAccountStatementRecipient(
      accountStatementRecipient
    );
  }

  setAndUpdateDailyContact(dailyContact: DailyContactInformation) {
    return this.rootStore.accountStore.requestToChangeDailyContact(dailyContact);
  }

  setAndUpdateGnssNotifications(gnssNotificationsInfo: GnssNotificationsInformation) {
    return this.rootStore.accountStore.requestToChangeGnssNotificationsSettings(
      gnssNotificationsInfo
    );
  }

  setAndUpdateContractManager(NewContractManager: Person) {
    return this.rootStore.accountStore.requestToUpdateContractManager(NewContractManager);
  }

  setAndUpdateAccountInfo(NewAccountInfo: AccountInfo) {
    return this.rootStore.accountStore.requestToUpdateAccountInfo(NewAccountInfo);
  }

  constructor(rootStore: RootStore) {
    super(rootStore);
    makeObservable(this, {
      accountInfo: observable,
      accountPaymentType: observable,
      contractManager: observable,
      dailyContactPersonName: observable,
      dailyContactPersonEmail: observable,
      dailyContactPersonPhone: observable,
      paymentMethod: observable,
      getAccountInfo: action,
      setAndUpdateInvoiceRecipient: action,
      setAndUpdateContractManager: action,
      setAndUpdateDailyContact: action
    });
  }
}
